<template>
    <el-card class="main-card" v-loading="loading">
        <div slot="header" style="display: flex; align-items: center; gap: 12px">
            <el-button type="primary" size="small" icon="el-icon-arrow-left" @click="back">返回</el-button>
            <span style="font-size: 18px; font-weight: bold">
                {{ (sizeInfo && sizeInfo.name) ? `尺寸详情：${sizeInfo.name}` : '模板产品尺寸详情' }}
            </span>
        </div>

        <template v-if="detail.id">
            <!-- 基本信息 -->
            <div class="section-title">基本信息</div>
            <el-descriptions :column="3" border size="medium">
                <el-descriptions-item label="ID">{{ detail.id }}</el-descriptions-item>
                <el-descriptions-item label="模板ID">{{ formatValue(detail.templateId) }}</el-descriptions-item>
                <el-descriptions-item label="尺寸ID">{{ formatValue(detail.sizeId) }}</el-descriptions-item>
                <el-descriptions-item label="状态">
                    <el-tag :type="detail.status === 1 ? 'success' : 'info'" size="mini">
                        {{ detail.status === 1 ? '已激活' : '停用' }}
                    </el-tag>
                </el-descriptions-item>
                <el-descriptions-item label="排序">{{ formatValue(detail.sortOrder) }}</el-descriptions-item>
                <el-descriptions-item label="备注">{{ formatValue(detail.remark) }}</el-descriptions-item>
                <el-descriptions-item label="创建人">{{ formatValue(detail.createdName) }}</el-descriptions-item>
                <el-descriptions-item label="创建时间">{{ formatValue(detail.createdTime) }}</el-descriptions-item>
                <el-descriptions-item label="更新时间">{{ formatValue(detail.updatedTime) }}</el-descriptions-item>
            </el-descriptions>

            <!-- 尺寸信息 -->
            <div class="section-title">尺寸信息</div>
            <template v-if="sizeInfo">
                <el-descriptions :column="3" border size="medium">
                    <el-descriptions-item label="尺寸名称">{{ formatValue(sizeInfo.name) }}</el-descriptions-item>
                    <el-descriptions-item label="尺寸编码">{{ formatValue(sizeInfo.code) }}</el-descriptions-item>
                    <el-descriptions-item label="尺寸值">{{ formatValue(sizeInfo.sizeValue) }}</el-descriptions-item>
                    <el-descriptions-item label="规格（长×宽×高 m）">
                        {{ sizeInfo.length }} × {{ sizeInfo.width }} × {{ sizeInfo.height }}
                    </el-descriptions-item>
                    <el-descriptions-item label="内部基础价">{{ formatPrice(sizeInfo.basePriceInner) }}</el-descriptions-item>
                    <el-descriptions-item label="外部基础价">{{ formatPrice(sizeInfo.basePriceOut) }}</el-descriptions-item>
                    <el-descriptions-item label="尺寸状态">
                        <el-tag :type="sizeInfo.status === 1 ? 'success' : 'info'" size="mini">
                            {{ sizeInfo.status === 1 ? '已激活' : '停用' }}
                        </el-tag>
                    </el-descriptions-item>
                    <el-descriptions-item label="尺寸排序">{{ formatValue(sizeInfo.sortOrder) }}</el-descriptions-item>
                    <el-descriptions-item label="尺寸更新时间">{{ formatValue(sizeInfo.updatedTime) }}</el-descriptions-item>
                </el-descriptions>
            </template>
            <el-empty v-else description="未获取到尺寸信息" :image-size="80"></el-empty>
        </template>

        <el-empty v-else-if="!loading" description="未查询到尺寸详情"></el-empty>
    </el-card>
</template>

<script>
import { templateProductSizeApi, productSizeList } from '@/api/quote'

export default {
    name: 'TemplateProductSizeDetail',
    props: {
        id: {
            type: [String, Number],
            required: true
        }
    },
    data() {
        return {
            loading: false,
            detail: {},
            sizeMap: {}, // 尺寸字典：详情接口不回填 productSize 时兜底
        }
    },
    computed: {
        // 尺寸信息：优先详情回填的 productSize，否则查字典
        sizeInfo() {
            return this.detail.productSize || this.sizeMap[this.detail.sizeId] || null
        }
    },
    mounted() {
        this.fetchDetail();
        this.fetchSizeMap();
    },
    methods: {
        // 获取尺寸详情
        async fetchDetail() {
            this.loading = true;
            try {
                const res = await templateProductSizeApi.detail(this.id)
                if (res && res.code === '0000') {
                    this.detail = res.result || {}
                }
            } catch (error) {
                console.error('获取模板产品尺寸详情失败：', error)
            } finally {
                this.loading = false;
            }
        },

        // 加载尺寸字典（详情接口不回填嵌套对象时用于关联展示）
        async fetchSizeMap() {
            try {
                const param = {
                    filter: [],
                    sorted: [],
                    current: 0,
                    size: 500,
                }
                const res = await productSizeList(param)
                if (res && res.code === '0000') {
                    const map = {};
                    (res.result.records || []).forEach(item => {
                        map[item.id] = item;
                    });
                    this.sizeMap = map;
                }
            } catch (error) {
                console.error('获取尺寸字典失败：', error)
            }
        },

        back() {
            this.$router.back();
        },

        // 空值展示兜底
        formatValue(val) {
            return val !== null && val !== undefined && val !== '' ? val : '--'
        },

        // 金额展示：千分位
        formatPrice(val) {
            if (val === null || val === undefined || val === '') return '--'
            return Number(val).toLocaleString()
        },
    }
}
</script>

<style scoped>
.main-card {
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
    border: none;
    min-height: 600px;
}

.section-title {
    font-size: 15px;
    font-weight: 600;
    color: #1f2937;
    margin: 24px 0 12px;
    padding-left: 10px;
    border-left: 3px solid #1890ff;
}

.section-title:first-of-type {
    margin-top: 0;
}
</style>
